module.exports = __webpack_public_path__ + "img/desserts.7d92f8b7.png";